import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../ApprovalRequest.css';
import StateSynchronizer from '../../../../../utils/StateSynchronizer';
class PersonalTradeRecognizeGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.personalTradeRecognizeGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100
      },
      rowSelection: "multiple",
    };
  }

  getRowNodeId = data => {
    return data.id;
  };


  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    const COLUMNS_KEY = 'personal-trade-list-reco-grid-col-state';

    StateSynchronizer.syncGrid(params, this.state.columnDefs, COLUMNS_KEY);
  };

  render() {
    const {
      personalTradeRecogResultArray,
      className = 'grid-wrapper',
      loadPersonalTradeRequestRecognizeResultActionStatus,
    } = this.props;

    const isLoading = loadPersonalTradeRequestRecognizeResultActionStatus === ACTION_STATUS.LOGINING;
    if (loadPersonalTradeRequestRecognizeResultActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadPersonalTradeRequestRecognizeResultActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={personalTradeRecogResultArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            sideBar={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default PersonalTradeRecognizeGrid;